module.exports = __webpack_public_path__ + "static/media/raise-hand-off.88b38d4f.svg";